<div class="acc-order-details">
  <div class="row account-overview-header">
    <div class="col-xs-4 col-sm-5 col-md-12">
      <h3 class="orders">
        {{ 'accountOrders.order_products_label' | cxTranslate }}
      </h3>
      <h6 class="ordersh6">
        {{ 'accountOrders.quick_order_label' | cxTranslate }}
      </h6>
      <p>{{ 'accountOrders.search_for_label' | cxTranslate }}</p>
    </div>
    <app-quick-order class="col-12 algn-Search"></app-quick-order>
  </div>
</div>
